/**
 * ISO 3166-1 alpha-3 → alpha-2 mapping.
 *
 * geoBoundaries CGAZ identifies countries by alpha-3 (`shapeGroup`, e.g.
 * "UKR"), but the incident data, COUNTRY_NAMES and COUNTRY_CENTERS in this app
 * are keyed by alpha-2 ("UA"). This bridges the two.
 *
 * Covers Europe + a few extras the app supports (US). Extend as needed — any
 * alpha-3 not present here simply won't be colorable on the world map.
 */
export const ISO3_TO_ISO2: Record<string, string> = {
  ALB: 'AL',
  AND: 'AD',
  AUT: 'AT',
  BEL: 'BE',
  BIH: 'BA',
  BGR: 'BG',
  HRV: 'HR',
  CYP: 'CY',
  CZE: 'CZ',
  DNK: 'DK',
  EST: 'EE',
  FIN: 'FI',
  FRA: 'FR',
  DEU: 'DE',
  GRC: 'GR',
  HUN: 'HU',
  ISL: 'IS',
  IRL: 'IE',
  ITA: 'IT',
  LVA: 'LV',
  LIE: 'LI',
  LTU: 'LT',
  LUX: 'LU',
  MLT: 'MT',
  MCO: 'MC',
  MDA: 'MD',
  MNE: 'ME',
  NLD: 'NL',
  NOR: 'NO',
  POL: 'PL',
  PRT: 'PT',
  ROU: 'RO',
  SMR: 'SM',
  SRB: 'RS',
  SVK: 'SK',
  SVN: 'SI',
  ESP: 'ES',
  SWE: 'SE',
  CHE: 'CH',
  UKR: 'UA',
  MKD: 'MK',
  GBR: 'GB',
  USA: 'US',
  CAN: 'CA',
  MEX: 'MX',
  TUR: 'TR',
  XKX: 'XK',
  KOS: 'XK',
  ISR: 'IL',
  BRA: 'BR',
  CHN: 'CN',
  COL: 'CO',
  ARE: 'AE',
  URY: 'UY',
  UZB: 'UZ',
  VEN: 'VE',
  VNM: 'VN',
  PER: 'PE',
  PRI: 'PR',
  DZA: 'DZ',
  AGO: 'AO',
  ZMB: 'ZM',
  ARG: 'AR',
  ARM: 'AM',
  AUS: 'AU',
  AZE: 'AZ',
  BHR: 'BH',
  BLR: 'BY',
  BEN: 'BJ',
  RUS: 'RU',
  BMU: 'BM',
  BTN: 'BT',
  BOL: 'BO',
  BWA: 'BW',
  CMR: 'CM',
  AFG: 'AF',
  BGD: 'BD',
  MAR: 'MA',
  CHL: 'CL',
  PRY: 'PY',
  ECU: 'EC',
  GUY: 'GY',
  SUR: 'SR',
  CUB: 'CU',
  CRI: 'CR',
  PAN: 'PA',
  DOM: 'DO',
  JAM: 'JM',
  HTI: 'HT',
  BHS: 'BS',
  JPN: 'JP',
  KOR: 'KR',
  TWN: 'TW',
  PHL: 'PH',
  IDN: 'ID',
  THA: 'TH',
  MYS: 'MY',
  KAZ: 'KZ',
  MNG: 'MN',
  IND: 'IN',
  GEO: 'GE',
  TJK: 'TJ',
  KGZ: 'KG',
  PNG: 'PG',
  NZL: 'NZ',
  LKA: 'LK',
  NPL: 'NP',
  MMR: 'MM',
  LAO: 'LA',
  KHM: 'KH',
  PAK: 'PK',
  GRL: 'GL',
  MDG: 'MG',
  TKM: 'TM',
  EGY: 'EG',
  ZAF: 'ZA',
  GTM: 'GT',
  BLZ: 'BZ',
  SLV: 'SV',
};
